//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import { Box } from '@mui/material';

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export default function Header() {
	return (
		<Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
			<Box width="100%" display="flex" alignItems="center" justifyContent="space-between"></Box>
		</Box>
	);
}
